import cookies from "../client/cookies";
class Interstitial {
    constructor(DOMelement) {
        try {
          this.el = DOMelement;          
          this.close = this.el.querySelector(".close_button");
          this.options = this.el.querySelectorAll("a");
          this.cookies = cookies;
          const ltgInterstitalCookie = this.cookies.read("LTG_Interstital");   
          if (!ltgInterstitalCookie) {
            this.showInterstitialBanner();
          }
       
          this.close.addEventListener("click", () => this.hideInterstitialBanner());
          this.options.forEach(element => {
            element.addEventListener("click",()=>this.hideInterstitialBanner());
          });
        } catch (error) {
          console.log(error);
        }   
      }
      hideInterstitialBanner = () => {
        if (this.el) {
          this.el.style.display = "none";
          this.cookies.create("LTG_Interstital", 'true');         
          this.showCookieBanner();
        }
      }
      showInterstitialBanner = () => {
        this.el.style.display = "flex"
      } 
      showCookieBanner = () => {
        const el = document.querySelector(".sd-cookie-notification");
         el.style.display = "block"
      }

}

export default Interstitial;